module.exports = __webpack_public_path__ + "img/load-2-3.56cadf50.png";